import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import dataConfig from '@/views/gucangSales/commonEnum/dataConfig'
import { customerContactAdd, customerContactEdit } from '@/api/gucangSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { contactValidate, concatNameValidate } from '@/utils/validate'
import { listByParamCodes } from '@/api/common'
import { cloneDeep } from 'lodash-es'

const __default__ = {
  name: 'ContactsModal'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  contactRefId: {
    type: String
  }
},
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const formRef = ref()
const loading = ref(false)
const visible = ref(false)
const form = ref<PotentialItem['contact']>({})
const paramCodeData = ref<{
  fbu_area_code: []
}>({
  fbu_area_code: [] // 电话区号
})
const emit = __emit
const props = __props
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_area_code']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const success = (type: 'add' | 'edit') => {
  emit('success', type)
}
const toggle = (row: PotentialItem['contact']) => {
  console.log(row)
  form.value = row ? cloneDeep(row) : {}
  visible.value = true
}
// 新增编辑提交
const handleSubmit = () => {
  formRef.value.validate().then(async () => {
    loading.value = true
    try {
      if (form.value?.id) {
        await customerContactEdit(form.value)
        message.success('编辑成功')
        success('edit')
      } else {
        await customerContactAdd({
          ...form.value,
          contactRefId: props.contactRefId
        })
        message.success('新增成功')
        success('add')
      }
      loading.value = false
      visible.value = false
    } catch (error) {
      loading.value = false
    }
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((visible).value = $event)),
    title: form.value.id ? '编辑' : '新增',
    class: "clueMerge",
    width: "870px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: form.value,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_dc_layout_card, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "contactType",
                    label: "联系人类型",
                    rules: {
            message: '请选择',
            required: true
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: form.value.contactType,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.contactType) = $event)),
                        options: _unref(dataConfig).contactTypeEnum,
                        placeholder: "请选择",
                        "allow-clear": ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "name",
                    rules: [
            {
              required: true,
              message: '请输入'
            },
            {
              validator: _unref(concatNameValidate)
            }
          ],
                    label: "联系人名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.name,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.name) = $event)),
                        placeholder: "请输入",
                        maxlength: 50
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    label: "手机号",
                    class: "form-item_compact"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.fbu_area_code,
                            value: form.value.mobileRegion,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.mobileRegion) = $event)),
                            style: {"width":"33%"}
                          }, null, 8, ["options", "value"]),
                          _createVNode(_component_a_form_item, {
                            style: {"width":"67%"},
                            class: "last-compact",
                            name: "mobile",
                            rules: {
                validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
              }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CosInput, {
                                value: form.value.mobile,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.mobile) = $event)),
                                placeholder: "请输入，联系方式必填其一"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }, 8, ["rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "email",
                    label: "邮箱",
                    rules: [
            {
              validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
            }
          ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.email,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.email) = $event)),
                        placeholder: "请输入，联系方式必填其一"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    name: "wechat",
                    label: "微信号",
                    rules: {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.wechat,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.wechat) = $event)),
                        placeholder: "请输入，联系方式必填其一"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    name: "qq",
                    label: "QQ号",
                    rules: {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.qq,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.qq) = $event)),
                        placeholder: "请输入，联系方式必填其一"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    label: "固定电话",
                    class: "form-item_compact"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.fbu_area_code,
                            value: form.value.telRegion,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.telRegion) = $event)),
                            style: {"width":"33%"}
                          }, null, 8, ["options", "value"]),
                          _createVNode(_component_a_form_item, {
                            span: 24,
                            style: {"width":"67%"},
                            class: "last-compact",
                            name: "tel",
                            rules: {
                validator: (rule, value) => _unref(contactValidate)(rule, value, form.value, formRef.value)
              }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CosInput, {
                                value: form.value.tel,
                                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.value.tel) = $event)),
                                placeholder: "请输入，联系方式必填其一"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }, 8, ["rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "性别" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: form.value.sex,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.sex) = $event)),
                        options: _unref(dataConfig).genderEnum,
                        placeholder: "请选择",
                        "allow-clear": ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "角色" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: form.value.jobRole,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((form.value.jobRole) = $event)),
                        options: _unref(dataConfig).linkRoleTypeEnum,
                        placeholder: "请选择",
                        "allow-clear": ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "部门职务" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.jobDuty,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((form.value.jobDuty) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "传真号" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.fax,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((form.value.fax) = $event)),
                        placeholder: "请输入",
                        maxlength: 50
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    label: "备注",
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosTextarea, {
                        value: form.value.remark,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((form.value.remark) = $event)),
                        placeholder: "请输入",
                        maxlength: 2000
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})